// Wipes every slice but the router. Dispatched at the end of the log out saga
// and handled by the root reducer, so it carries no AUTH/ prefix.
export const CLEAR_STORE = 'CLEAR_STORE';

const PREFIX = 'AUTH/';
export const AUTH_LOGIN = `${PREFIX}LOGIN`;
export const AUTH_LOGOUT = `${PREFIX}LOGOUT`;
export const AUTH_FORGOT_PASSWORD = `${PREFIX}FORGOT_PASSWORD`;
export const AUTH_CHANGE_PASSWORD = `${PREFIX}CHANGE_PASSWORD`;
export const AUTH_RESET_PASSWORD = `${PREFIX}RESET_PASSWORD`;
export const AUTH_VERIFY_SESSION = `${PREFIX}VERIFY_SESSION`;

export const AUTH_REMEMBER_ME = `${PREFIX}REMEMBER_ME`;
export const AUTH_CLEAN = `${PREFIX}CLEAN`;

export const AUTH_SHOW_PASSWORD = `${PREFIX}SHOW_PASSWORD`;
export const AUTH_SHOW_NEW_PASSWORD = `${PREFIX}SHOW_NEW_PASSWORD`;
export const AUTH_SHOW_CONFIRM_PASSWORD = `${PREFIX}SHOW_CONFIRM_PASSWORD`;
